module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kj-done"
  }, [_c('div', {
    staticClass: "kj-done-cont"
  }, [_c('img', {
    staticClass: "kj-done-img",
    attrs: {
      "src": require("./copper.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kj-done-tips"
  }, [_c('div', {
    staticClass: "kj-done-good"
  }, [_vm._v("好棒！你帮 "), _c('span', [_vm._v(_vm._s(decodeURIComponent(_vm.congratulationInf.nickName)))])]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-cut"
  }, [_vm._v("砍掉了"), _c('span', [_vm._v("￥" + _vm._s(_vm.congratulationInf.price))])])]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-btns"
  }, [(_vm.isShowButton) ? [_c('button', {
    on: {
      "click": _vm.handleHelpClick
    }
  }, [_vm._v("请朋友帮砍")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.showSelectButton
    }
  }, [_vm._v("立即购买")])] : [_c('button', {
    on: {
      "click": _vm.handleHelpClick
    }
  }, [_vm._v("帮他拉人")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.handleJoinYourselfClick
    }
  }, [_vm._v("我也要参与")])]], 2), _vm._v(" "), _c('button', {
    staticClass: "kj-done-back",
    on: {
      "click": _vm.handleBackClick
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('yd-popup', {
    attrs: {
      "position": "bottom",
      "height": "auto"
    },
    model: {
      value: (_vm.contentShow),
      callback: function($$v) {
        _vm.contentShow = $$v
      },
      expression: "contentShow"
    }
  }, [_c('div', {
    staticClass: "kj-done-info"
  }, [_c('button', {
    staticClass: "kj-done-close",
    on: {
      "click": function($event) {
        _vm.contentShow = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./close.svg")
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "kj-done-info_head"
  }, [_vm._v("活动说明")]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-info_box"
  }, [_c('div', {
    staticClass: "kj-done-info_item"
  }, [_c('div', {
    staticClass: "kj-done-info_label"
  }, [_vm._v("方法1:")]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-info_cont"
  }, [_c('p', [_vm._v("长按下图保存发给朋友们")]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-info_imgs"
  }, [_c('div', {
    staticClass: "kj-done-info_share_img-wrap"
  }, [(_vm.base64Img) ? _c('img', {
    staticClass: "kj-done-info_share_img",
    style: ({
      opacity: _vm.base64Img ? 1 : 0
    }),
    attrs: {
      "crossorigin": "anonymous",
      "id": "kj-canvas-img",
      "src": _vm.base64Img
    }
  }) : _vm._e()]), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "kj-canvas",
      "width": "540",
      "height": "815"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "kj-done-info_arrow",
    attrs: {
      "src": require("./arrow.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-info_item"
  }, [_c('div', {
    staticClass: "kj-done-info_label"
  }, [_vm._v("方法2:")]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-info_cont"
  }, [_c('p', [_vm._v("复制以下链接发给朋友们")]), _vm._v(" "), _c('div', {
    staticClass: "kj-done-info_copy"
  }, [_vm._v("我非常想要这个宝贝，大家快来帮我砍个价，能省一点是一点，猛戳链接：" + _vm._s(this.shortUrl))])])])])])]), _vm._v(" "), _c('TkSkuPopup', {
    attrs: {
      "type": "cart",
      "product-id": _vm.item.product_id,
      "sku": _vm.item.variant_id,
      "quantity": _vm.item.quantity,
      "amountAfter": _vm.bargainAmountAfter
    },
    on: {
      "change": _vm.handleSelectCommodity
    },
    model: {
      value: (_vm.onOpt),
      callback: function($$v) {
        _vm.onOpt = $$v
      },
      expression: "onOpt"
    }
  }), _vm._v(" "), (_vm.bargaining) ? _c('div', {
    staticClass: "kj-done-ani"
  }, [_c('BargainAnimation')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8094ea50","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bargainResult/index.vue
// module id = 290
// module chunks = 0